module.exports = __webpack_public_path__ + "static/media/my-purchases.1ff7e83e.svg";